import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Login from '@/components/Login.vue'
import Exercises from '@/components/Exercises.vue'
import MedicalCases from '@/components/MedicalCases.vue'
import Exercise from '@/components/Exercise.vue'
import MedicalCase from '@/components/MedicalCase.vue'
import Teams from '@/components/Teams.vue'
import Team from '@/components/Team.vue'
import Roleplayers from '@/components/Roleplayers.vue'
import Roleplayer from '@/components/Roleplayer.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
      path: '/',
      name: 'home',
      component: Home,
      beforeEnter: requireAuth
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      beforeEnter: noLoginTwice
    },
    {
      path: '/exercises',
      name: 'exercises',
      component: Exercises,
      beforeEnter: requireAuth
    },
    {
      path: '/medical_cases',
      name: 'medical_cases',
      component: MedicalCases,
      beforeEnter: requireAuth
    },
    {
      path: '/exercises/:id',
      name: 'exercise',
      component: Exercise,
      beforeEnter: requireAuth
    },
    {
      path: '/medical_cases/:id',
      name: 'medical_case',
      component: MedicalCase,
      beforeEnter: requireAuth
    },
    {
      path: '/exercises/:e_id/teams',
      name: 'teams',
      component: Teams,
      beforeEnter: requireAuth
    },
    {
      path: '/exercises/:e_id/teams/:id',
      name: 'team',
      component: Team,
      beforeEnter: requireAuth
    },
    {
      path: '/exercises/:e_id/roleplayers',
      name: 'roleplayers',
      component: Roleplayers,
      beforeEnter: requireAuth
    },
    {
      path: '/exercises/:e_id/roleplayers/:id',
      name: 'roleplayer',
      component: Roleplayer,
      beforeEnter: requireAuth
    }
  ]
})
router.beforeEach((to, from, next) => {
  document.title = process.env.VUE_APP_TITLE;
  next();
});

function noLoginTwice(to, from, next) {
  if (isLogedIn()) {
    next({
      path: '/',
      query: {
        redirect: to.fullPath
      }
    });
  } else {
    next();
  }
}

function requireAuth(to, from, next) {
  if (!isLogedIn()) {
    next({
      path: '/login',
      query: {
        redirect: to.fullPath
      }
    });
  } else {
    next();
  }
}

function isLogedIn() {
  if (localStorage.getItem("isLogedIn") === null) {
    return false
  }
  return true
}

export default router;